<template>
  <div class="main">
    <c-panel>
      <form-tipo-alimento :paramId="$route.params.id" v-on:onSubmitTipoAlimento="onSubmitTipoAlimento"></form-tipo-alimento>
    </c-panel>
  </div>
</template>
<script>
import formTipoAlimento from "./form"

export default {
  methods: {
    onSubmitTipoAlimento () {
      this.$router.push('/admin/merenda/tipo-alimento')
    }
  },
  components: { formTipoAlimento }
}
</script>
